__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/1719e14/_next/";